/**
 * 登録 / 更新 / 削除 / 画面を閉じる操作で表示する確認メッセージ (Issue #765)。
 *
 * 現場 WG アプリの各画面で文言をそろえるため、ここに集約する。
 */

/** 登録 / 更新 / 削除ボタン押下時の確認 */
export const CONFIRM_EXECUTE_TITLE = '実行の確認';
export const CONFIRM_EXECUTE_MESSAGE = '実行してよろしいですか？';
export const CONFIRM_EXECUTE_LABEL = '実行';

/** 登録 / 更新せずに画面 (モーダル / 編集行) を閉じるときの確認 */
export const CONFIRM_DISCARD_TITLE = '変更内容の破棄';
export const CONFIRM_DISCARD_MESSAGE = '変更内容は破棄されますが宜しいですか？';
export const CONFIRM_DISCARD_LABEL = '破棄する';

/** 更新確定時に、開いた後で他者が同じデータを更新していたときの確認 (Issue #765) */
export const CONFIRM_OVERWRITE_TITLE = '他者による更新';
export const CONFIRM_OVERWRITE_MESSAGE = '他者が更新していますが、更新してもよろしいでしょうか？';
export const CONFIRM_OVERWRITE_LABEL = '更新する';

/** 更新確定時に、開いた後で他者が同じデータを削除していたときのお知らせ (Issue #765) */
export const NOTICE_DELETED_BY_OTHERS_TITLE = '他者による削除';
export const NOTICE_DELETED_BY_OTHERS_MESSAGE =
  '変更したデータは、他者によって削除されております。';

/** 他者による更新 / 削除の確認に失敗したとき (最新の状態を取得できなかった) */
export const REMOTE_CHECK_FAILED_MESSAGE =
  '最新の状態を確認できませんでした。時間をおいて再度お試しください。';
